/**
 * A reusable button component matching the designs from Figma
 */
import React, { useEffect, useRef, useState } from 'react';
import { TableTitle, TableWrapper, TableHeaderRow, TableHeaderCell, TableRow, WrappedTableCell, TooltipTableCell, EmptyText, EmptySmallText, GraphicWrapper, } from './Table.styled';
import { Error, Loading, Tooltip } from '../index';
var Table = function (_a) {
    var _b = _a.title, title = _b === void 0 ? '' : _b, _c = _a.data, data = _c === void 0 ? [] : _c, _d = _a.columns, columns = _d === void 0 ? [] : _d, _e = _a.width, width = _e === void 0 ? '100%' : _e, _f = _a.height, height = _f === void 0 ? '100%' : _f, _g = _a.loading, loading = _g === void 0 ? false : _g, _h = _a.error, error = _h === void 0 ? false : _h, _j = _a.empty, empty = _j === void 0 ? false : _j;
    if (error) {
        return (React.createElement(GraphicWrapper, { height: height, width: width },
            React.createElement(Error, null)));
    }
    if (loading) {
        return (React.createElement(GraphicWrapper, { height: height, width: width },
            React.createElement(Loading, null)));
    }
    return (React.createElement(TableWrapper, { width: width, height: height },
        title && title.length > 0 && React.createElement(TableTitle, null, title),
        React.createElement(TableHeader, { columns: columns }),
        empty ? (React.createElement(React.Fragment, null,
            React.createElement(EmptyText, null, "No search results!"),
            React.createElement(EmptySmallText, null, "Try broadening your search parameters or refreshing the dates."))) : (React.createElement(TableBody, { data: data, columns: columns }))));
};
var TableHeader = function (_a) {
    var _b = _a.columns, columns = _b === void 0 ? [] : _b;
    return (React.createElement(TableHeaderRow, null, columns.map(function (_a) {
        var title = _a.title, flex = _a.flex, field = _a.field;
        return (React.createElement(TableHeaderCell, { key: field, flex: flex }, title));
    })));
};
var TableCell = function (_a) {
    var _b = _a.content, content = _b === void 0 ? '' : _b, _c = _a.flex, flex = _c === void 0 ? 1 : _c, _d = _a.isText, isText = _d === void 0 ? true : _d, _e = _a.wrapOverflow, wrapOverflow = _e === void 0 ? false : _e;
    var _f = useState(false), hasOverflow = _f[0], setHasOverflow = _f[1];
    var overflowRef = useRef(null);
    var hasOverflowText = function (element) {
        return (element &&
            (element.offsetHeight < element.scrollHeight || element.offsetWidth < element.scrollWidth));
    };
    var handleCellCopy = function (cell) {
        navigator.clipboard.writeText(cell);
    };
    useEffect(function () {
        if (hasOverflowText(overflowRef.current)) {
            setHasOverflow(true);
            return;
        }
        setHasOverflow(false);
    }, [hasOverflow]);
    if (wrapOverflow) {
        return (React.createElement(WrappedTableCell, { flex: flex, ref: overflowRef, onClick: function () { return isText && handleCellCopy(content); } },
            React.createElement(Tooltip, { content: "Click to copy" }, content)));
    }
    return (React.createElement(TooltipTableCell, { flex: flex, ref: overflowRef, onClick: function () { return isText && handleCellCopy(content); }, activeTooltip: hasOverflow, tooltipContent: isText && hasOverflow ? content : '' }, content));
};
var TableBody = function (_a) {
    var _b = _a.data, data = _b === void 0 ? [] : _b, _c = _a.columns, columns = _c === void 0 ? [] : _c;
    return (React.createElement("div", null, data.map(function (row) { return (React.createElement(TableRow, { key: row.id }, columns.map(function (_a) {
        var field = _a.field, flex = _a.flex, isText = _a.isText, wrapOverflow = _a.wrapOverflow;
        return (React.createElement(TableCell, { key: field, flex: flex, content: row[field], isText: isText, wrapOverflow: wrapOverflow }));
    }))); })));
};
export default Table;
